<!-- iframe  支付宝扫码页面 -->
<template>
	<div  id = "afterAliPay" >
	</div>
</template>

<script>
    export default {
        name: 'AfterAliPay',
        data(){
            return {
            }
        } ,

        created(){
			
        },

        mounted () {

            if (navigator.userAgent.indexOf("MSIE") > 0) {     
                if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {     
                    window.opener = null; 
                    window.close();     
                }     
                else {     
                    window.open('', '_top'); 
                    window.top.close();     
                }     
            }        
            else {     
                window.open('', '_self');  
                window.close();     
            }     
	    }


    }
</script>